import MobileLogo from '../src/MobileLogo.tsx';
export default MobileLogo;
